module.exports = __webpack_public_path__ + "static/media/KH.d5d8406b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KH.svg
// module id = 288
// module chunks = 0